export const admin: Record<string, string> = {
  'Active': 'Actif',
  'Admin access': 'Accès administrateur',
  'Account management': 'Gestion des comptes',
  'Alex Morgan': 'Alex Morgan',
  'alex@company.com': 'alex@entreprise.com',
  'Apply four-hour minimum shift pay rule':
    'Appliquer la règle de rémunération minimale de quatre heures par vacation',
  'Base hourly rate (Security ERO)': 'Taux horaire de base (ERO sécurité)',
  'Choose a roster date window for the payroll run.':
    'Choisissez une période de planning pour le traitement de la paie.',
  'Company admins': 'Administrateurs de l’entreprise',
  'Confirm temporary password': 'Confirmer le mot de passe temporaire',
  'Create admin account': 'Créer un compte administrateur',
  'Create and review company administrator accounts for this operations workspace.':
    'Créez et contrôlez les comptes administrateurs de l’entreprise pour cet espace opérationnel.',
  'Defaults follow current Irish security-sector payroll rules and can be changed before export.':
    'Les valeurs par défaut suivent les règles de paie irlandaises en vigueur dans le secteur de la sécurité et peuvent être modifiées avant l’exportation.',
  'Disabled': 'Désactivé',
  'Employee': 'Employé',
  'Employee summary': 'Récapitulatif par employé',
  'End date': 'Date de fin',
  'Estimated total': 'Total estimé',
  'Export CSV': 'Exporter au format CSV',
  'Export period': 'Période d’exportation',
  'Export worked hours and Irish security-sector premium indicators from completed shift records.':
    'Exportez les heures travaillées et les indicateurs de majoration du secteur irlandais de la sécurité à partir des vacations terminées.',
  'Full name': 'Nom complet',
  'Loading admin accounts...': 'Chargement des comptes administrateurs...',
  'Loading payroll settings...': 'Chargement des paramètres de paie...',
  'Minimum shift pay (hours)': 'Rémunération minimale par vacation (heures)',
  'New accounts are created in Supabase Auth and linked to this company.':
    'Les nouveaux comptes sont créés dans Supabase Auth et associés à cette entreprise.',
  'No company admins found.': 'Aucun administrateur d’entreprise trouvé.',
  'No started shifts found for this period.':
    'Aucune vacation commencée n’a été trouvée pour cette période.',
  'Payable': 'À payer',
  'Payable hours': 'Heures payables',
  'Payroll assumptions': 'Hypothèses de paie',
  'Payroll export': 'Exportation de la paie',
  'Payroll review warnings': 'Avertissements de contrôle de la paie',
  'Premiums': 'Majorations',
  'Public holiday': 'Jour férié',
  'Public holiday additional pay multiplier':
    'Coefficient de rémunération supplémentaire des jours fériés',
  'Public holiday hours': 'Heures de jour férié',
  'Review': 'Contrôler',
  'Role': 'Rôle',
  'Start date': 'Date de début',
  'Sunday': 'Dimanche',
  'Sunday hours': 'Heures du dimanche',
  'Sunday premium top-up multiplier': 'Coefficient de majoration du dimanche',
  'Temporary password': 'Mot de passe temporaire',
  'Total admins': 'Nombre total d’administrateurs',
  'Unsocial': 'Heures atypiques',
  'Unsocial premium per shift': 'Majoration des heures atypiques par vacation',
  'Unsocial shifts': 'Vacations en heures atypiques',
  'Unsocial threshold (hours)': 'Seuil des heures atypiques (heures)',
  'Use security ERO unsocial-hours rate schedule':
    'Utiliser la grille ERO sécurité pour les heures atypiques',
  'A valid email address is required': 'Une adresse e-mail valide est requise',
  'Admin account created for {email}.': 'Compte administrateur créé pour {email}.',
  'Failed to create admin account': 'Impossible de créer le compte administrateur',
  'Failed to generate payroll export': 'Impossible de générer l’exportation de la paie',
  'Failed to load admin accounts': 'Impossible de charger les comptes administrateurs',
  'Failed to load payroll settings': 'Impossible de charger les paramètres de paie',
  'Failed to save payroll settings': 'Impossible d’enregistrer les paramètres de paie',
  'Full name is required': 'Le nom complet est requis',
  'Not recorded': 'Non renseigné',
  'Payroll export generated for {range}.': 'Exportation de la paie générée pour {range}.',
  'Payroll settings saved.': 'Paramètres de paie enregistrés.',
  'All time': 'Toute la période',
  'Create account': 'Créer le compte',
  'Created {date}': 'Créé le {date}',
  'Email unavailable': 'Adresse e-mail indisponible',
  'Irish shifts are protected by effective-dated Security ERO floors: EUR 15.41 from 22 July 2025 and EUR 16.15 from 28 September 2026, plus the EUR 20 unsocial-hours shift premium, 21:00-07:00 window, 3-hour threshold, and 4-hour minimum shift pay. Lower company or pay-band values cannot reduce those Irish entitlements. Sunday premium defaults to a 25% top-up starting assumption because Irish law requires a Sunday benefit where it is not already included, but does not set one universal multiplier.':
    'Les vacations irlandaises sont protégées par les minima de l’ERO sécurité datés : 15,41 EUR à compter du 22 juillet 2025 et 16,15 EUR à compter du 28 septembre 2026, ainsi que la prime de 20 EUR par vacation en heures atypiques, la plage 21:00-07:00, le seuil de 3 heures et le minimum de rémunération de 4 heures. Des valeurs d’entreprise ou de grille inférieures ne peuvent pas réduire ces droits irlandais. La majoration du dimanche est fixée par défaut à 25 % comme hypothèse de départ, car la loi irlandaise exige un avantage dominical lorsqu’il n’est pas déjà inclus, sans définir de coefficient universel.',
  'Generate': 'Générer',
  'Generating...': 'Génération...',
  'Payroll settings up to date': 'Paramètres de paie à jour',
  'Save settings': 'Enregistrer les paramètres',
  'Unnamed admin': 'Administrateur sans nom',
  'Unsaved payroll settings': 'Paramètres de paie non enregistrés',
  '{count} active account can open this workspace.':
    '{count} compte actif peut ouvrir cet espace de travail.',
  '{count} active accounts can open this workspace.':
    '{count} comptes actifs peuvent ouvrir cet espace de travail.',
  '{count} employee included. Generated {date}.':
    '{count} employé inclus. Généré le {date}.',
  '{count} employees included. Generated {date}.':
    '{count} employés inclus. Généré le {date}.',
  '{count} shifts': '{count} vacations',
  '{startDate} to {endDate}': 'du {startDate} au {endDate}',
  'Temporary password must be at least 8 characters':
    'Le mot de passe temporaire doit contenir au moins 8 caractères',
  'Temporary password must contain at least one lowercase letter':
    'Le mot de passe temporaire doit contenir au moins une lettre minuscule',
  'Temporary password must contain at least one number':
    'Le mot de passe temporaire doit contenir au moins un chiffre',
  'Temporary password must contain at least one uppercase letter':
    'Le mot de passe temporaire doit contenir au moins une lettre majuscule',
  'Temporary passwords do not match': 'Les mots de passe temporaires ne correspondent pas',
  'Privacy Reviews': 'Examens de confidentialité',
  'Account deletion and retention decisions':
    'Suppression des comptes et décisions de conservation',
  'Privacy operations': 'Opérations de confidentialité',
  'Account deletion reviews': 'Examens des suppressions de compte',
  'The login and direct personal account data shown here have already been deleted. Review only the employer-controlled work records that remain, document a lawful basis, and set a firm end date.':
    'L’identifiant et les données personnelles directes du compte affichés ici ont déjà été supprimés. Examinez uniquement les dossiers professionnels restants sous le contrôle de l’employeur, documentez une base juridique et fixez une date de fin ferme.',
  'Privacy review summary': 'Résumé des examens de confidentialité',
  'Pending review': 'En attente d’examen',
  'Overdue': 'En retard',
  'Reviewed': 'Examiné',
  'Do not retain records merely because they may be useful. GDPR requires a specific lawful purpose, data minimisation, restricted access, and deletion when that purpose ends. The suggested dates are platform defaults; your organisation remains responsible for verifying the applicable law and any legal hold.':
    'Ne conservez pas des dossiers uniquement parce qu’ils pourraient être utiles. Le RGPD exige une finalité juridique précise, la minimisation des données, un accès restreint et la suppression lorsque cette finalité prend fin. Les dates suggérées sont les valeurs par défaut de la plateforme ; votre organisation reste responsable de la vérification du droit applicable et de toute obligation de conservation.',
  'Loading privacy reviews...': 'Chargement des examens de confidentialité…',
  'No account deletion reviews require attention.':
    'Aucun examen de suppression de compte ne nécessite d’attention.',
  'Controller review required': 'Examen requis par le responsable du traitement',
  'Retention decision recorded': 'Décision de conservation enregistrée',
  'Account deleted': 'Compte supprimé',
  'Review due': 'Examen à effectuer avant le',
  'Working time and payroll': 'Temps de travail et paie',
  'Incident and safety': 'Incidents et sécurité',
  'Licence compliance': 'Conformité des licences',
  'Shift-bounded location': 'Localisation limitée au service',
  '{count} linked records': '{count} dossiers liés',
  'Suggested latest review/deletion date':
    'Date limite suggérée d’examen ou de suppression',
  'Documented lawful basis and necessity':
    'Base juridique et nécessité documentées',
  'Delete or review again by': 'Supprimer ou réexaminer avant le',
  'Internal note (optional)': 'Note interne (facultative)',
  'Record retention review': 'Enregistrer l’examen de conservation',
  'Retention review recorded': 'Examen de conservation enregistré',
  'Retention deadline reached': 'Échéance de conservation atteinte',
  'The recorded retention deadline has passed. Delete the records under your approved procedure, or document a renewed lawful basis and end date without delay.':
    'L’échéance de conservation enregistrée est dépassée. Supprimez les dossiers selon votre procédure approuvée ou documentez sans délai une nouvelle base juridique et une nouvelle date de fin.',
  'No review note recorded.': 'Aucune note d’examen enregistrée.',
  'Record a specific lawful reason for retaining these records.':
    'Indiquez un motif juridique précis pour conserver ces dossiers.',
  'Choose a future deletion or review date.':
    'Choisissez une future date de suppression ou d’examen.',
  'Retention review recorded for {reference}.':
    'Examen de conservation enregistré pour {reference}.',
  'Failed to load privacy reviews':
    'Impossible de charger les examens de confidentialité',
  'Failed to record retention review':
    'Impossible d’enregistrer l’examen de conservation',

  // Roles & Permissions
  'Roles & Permissions': 'Rôles et autorisations',
  'Decide what each role can open. Somebody can hold several roles, and gets everything any of them opens.':
    'Définissez ce que chaque rôle peut ouvrir. Une personne peut avoir plusieurs rôles et accède à tout ce que l’un d’eux ouvre.',
  'The top administrator of this workspace: the account that created it, until ownership is transferred. If the owner is deactivated, the longest-serving system administrator takes over.':
    'L’administrateur principal de cet espace de travail : le compte qui l’a créé, jusqu’au transfert de la propriété. Si le propriétaire est désactivé, l’administrateur système le plus ancien prend la relève.',
  'Nobody yet': 'Personne pour l’instant',
  'Transfer ownership': 'Transférer la propriété',
  'Transferring...': 'Transfert...',
  'Make somebody a system administrator first.': 'Nommez d’abord quelqu’un administrateur système.',
  'The new owner becomes the top administrator of this workspace. You stay a system administrator, and only they can transfer ownership back.':
    'Le nouveau propriétaire devient l’administrateur principal de cet espace de travail. Vous restez administrateur système, et lui seul pourra vous retransférer la propriété.',
  'New System Owner': 'Nouveau propriétaire du système',
  'Choose a system administrator': 'Choisissez un administrateur système',
  'Choose who takes over': 'Choisissez qui prend la relève',
  'Could not transfer ownership.': 'Impossible de transférer la propriété.',
  '{name} is now the System Owner. You are still a system administrator.':
    '{name} est désormais le propriétaire du système. Vous restez administrateur système.',
  'Guard roles': 'Rôles d’agent',
  'New guard role': 'Nouveau rôle d’agent',
  'New management role': 'Nouveau rôle de gestion',
  'Built-in': 'Intégré',
  'Areas this role opens': 'Sections ouvertes par ce rôle',
  'No default pay set': 'Aucune rémunération par défaut définie',
  '{count} person': '{count} personne',
  '{count} people': '{count} personnes',
  'Move its members to another role before deleting it.':
    'Déplacez ses membres vers un autre rôle avant de le supprimer.',
  'Edit role': 'Modifier le rôle',
  'Role name': 'Nom du rôle',
  'A role needs a name': 'Un rôle doit avoir un nom',
  'Colour': 'Couleur',
  'No colour': 'Aucune couleur',
  'Workspace areas this role opens': 'Sections de l’espace de travail ouvertes par ce rôle',
  'Pay rates, billing, privacy reviews, join codes and roles stay with system administrators.':
    'Les taux de rémunération, la facturation, les examens de confidentialité, les codes d’adhésion et les rôles restent réservés aux administrateurs système.',
  'Default hourly pay': 'Rémunération horaire par défaut',
  'Enter a valid hourly rate': 'Saisissez un taux horaire valide',
  'In your payroll currency. Payroll uses it for a guard in this role who has no pay band assigned; a pay band always takes precedence.':
    'Dans la devise de votre paie. La paie l’utilise pour un agent ayant ce rôle sans grille salariale affectée ; une grille salariale est toujours prioritaire.',
  'Create role': 'Créer le rôle',
  'Could not save this role.': 'Impossible d’enregistrer ce rôle.',
  '{name} has been created. Give it to people from their Staff profile.':
    '{name} a été créé. Attribuez-le depuis le profil de chaque personne dans Personnel.',
  '{name} has been updated. The change applies the next time its members load the workspace.':
    '{name} a été mis à jour. Le changement s’applique au prochain chargement de l’espace de travail par ses membres.',
  'Delete {name}?': 'Supprimer {name} ?',
  'Nobody holds this role, so nobody loses access. This cannot be undone.':
    'Personne n’a ce rôle, donc personne ne perd d’accès. Cette action est irréversible.',
  'Delete role': 'Supprimer le rôle',
  'Could not delete this role.': 'Impossible de supprimer ce rôle.',
  '{name} has been deleted.': '{name} a été supprimé.',

  // What each workspace permission covers. Reached through a variable
  // (PERMISSION_CATALOGUE), so check:i18n cannot see them.
  'Home, live view and shift history': 'Accueil, vue en direct et historique des vacations',
  'Duty board, shifts and leave': 'Tableau de service, vacations et congés',
  'Panic alerts and the response queue': 'Alertes de détresse et file d’intervention',
  'Staff directory, invites, licence checks and guard ranks':
    'Annuaire du personnel, invitations, vérification des licences et rangs des agents',
  'Incident reports and summary reports': 'Rapports d’incident et rapports de synthèse',
  'Timesheets, pay periods and gross pay previews':
    'Feuilles de temps, périodes de paie et aperçus du salaire brut',
  'Client contracts, client portal access and cover requests':
    'Contrats clients, accès au portail client et demandes de couverture',
};
